// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1yidq","title":"Header_title__2ABhI","left":"Header_left__20_n2","clinicName":"Header_clinicName__2StJU"};